import React from "react";
import { Button, Nav } from "react-bootstrap";
import imgIcon from '../../assets/images/userIcon.png';


const LeadScreen = () => {
    return (
        <>
            <div className="container-fluid mb-2">
                <div className="row">
                    <div className="col-12">
                        <div className="lead-card d-flex justify-content-between align-items-center p-3">
                            {/* Left Section */}
                            <div className="d-flex align-items-center gap-3">
                                {/* Back Icon */}
                                <span className="back-arrow">←</span>

                                {/* Avatar */}
                                <div className="d-flex align-items-center gap-2">
                                    <img
                                        src={imgIcon}
                                        alt="profile"
                                        className="avatar"
                                    />
                                    <div>
                                        <h6 className="fw-bold mb-0">Sarah Johnson</h6>
                                        <small className="text-muted">
                                            VP of Technology at TechCorp Inc.
                                        </small>
                                    </div>
                                </div>
                            </div>

                            {/* Middle Section */}
                            <div className="d-flex align-items-center gap-3">
                                <span className="status-badge">Qualified</span>
                                <span className="deal-amount">$125,000</span>
                                <span className="text-muted">• 65% probability</span>
                            </div>

                            {/* Right Section */}
                            <div className="d-flex gap-2">
                                <Button variant="outline-primary" className="btn-note">
                                    💬 Add Note
                                </Button>
                                <Button className="btn-visit">
                                    📅 Schedule Visit
                                </Button>
                                <Button className="btn-advance">
                                    📈 Advance Stage
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            <div className="container-fluid lead-details">
                <div className="row">
                    {/* Left Panel */}
                    <div className="col-md-3">
                        <div className="card p-3 mb-3">
                            <div className="text-center">
                                <img
                                    src={imgIcon}
                                    alt="Sarah Johnson"
                                    className="avatar-lg"
                                />
                                <h6 className="fw-bold mt-2">Sarah Johnson</h6>
                                <p className="text-muted mb-1">VP of Technology</p>
                                <p className="fw-semibold">TechCorp Inc.</p>
                            </div>

                            <div className="mt-3">
                                <p>📧 sarah.j@techcorp.com</p>
                                <p>📞 +1 (555) 123-4567</p>
                                <p>📍 San Francisco, CA</p>
                                <p>🌐 https://techcorp.com</p>
                            </div>

                            <div className="d-flex gap-2 mt-3">
                                <Button variant="primary" className="w-50">📞 Call</Button>
                                <Button variant="success" className="w-50">💬 WhatsApp</Button>
                            </div>
                        </div>

                        {/* Company Details */}
                        <div className="card p-3 mb-3">
                            <h6 className="fw-bold mb-3">🏢 Company Details</h6>
                            <p><strong>Industry:</strong> Technology</p>
                            <p><strong>Size:</strong> 500-1000 employees</p>
                            <p><strong>Revenue:</strong> $50M - $100M</p>
                            <p><strong>Source:</strong> Website Demo Request</p>
                        </div>
                    </div>

                    {/* Middle Panel */}
                    <div className="col-md-6">
                        <div className="card p-3 mb-3">
                            {/* Tabs */}
                            <Nav variant="tabs" defaultActiveKey="timeline">
                                <Nav.Item>
                                    <Nav.Link eventKey="timeline">📌 Timeline</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="files">📂 Files</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="communication">💬 Communication</Nav.Link>
                                </Nav.Item>
                            </Nav>

                            {/* Action Buttons */}
                            <div className="d-flex gap-2 mt-3">
                                <Button variant="primary">➕ Add Note</Button>
                                <Button variant="success">📅 Schedule Visit</Button>
                                <Button className="btn-advance">📈 Advance Stage</Button>
                                <Button variant="warning">💬 WhatsApp</Button>
                            </div>
                        </div>

                        {/* Timeline */}
                        <div className="timeline">
                            <div className="timeline-item">
                                <span className="icon">💬</span>
                                <div>
                                    <h6>Discovery Call Completed</h6>
                                    <p>Great conversation about their tech stack. Budget approved for Q4.</p>
                                    <small>by John Smith • 2025-08-22 14:30</small>
                                </div>
                            </div>

                            <div className="timeline-item">
                                <span className="icon">📅</span>
                                <div>
                                    <h6>Demo Scheduled</h6>
                                    <p>Technical demo scheduled for next Tuesday. Team of 3 engineers.</p>
                                    <small>by System • 2025-08-21 09:15</small>
                                </div>
                            </div>

                            <div className="timeline-item">
                                <span className="icon">📧</span>
                                <div>
                                    <h6>Proposal Sent</h6>
                                    <p>Sent detailed proposal including pricing & implementation.</p>
                                    <small>by John Smith • 2025-08-20 16:45</small>
                                </div>
                            </div>

                            <div className="timeline-item">
                                <span className="icon">📞</span>
                                <div>
                                    <h6>Initial Contact Call</h6>
                                    <p>First call - 25 minutes. Discussed pain points & solutions.</p>
                                    <small>2025-08-18 11:00</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Panel */}
                    <div className="col-md-3">
                        {/* Lead Score */}
                        <div className="card p-3 mb-3 text-center">
                            <h6>⭐ Lead Score</h6>
                            <h2 className="text-success fw-bold">85</h2>
                            <p className="text-muted">High Quality Lead</p>
                            <div className="progress">
                                <div className="progress-bar bg-success" style={{ width: "85%" }}></div>
                            </div>
                        </div>

                        {/* Next Actions */}
                        <div className="card p-3 mb-3">
                            <h6 className="fw-bold mb-2">📌 Next Actions</h6>
                            <div className="action-item bg-warning-subtle">⚠ Follow-up call due <br /> Tomorrow at 2:00 PM</div>
                            <div className="action-item bg-primary-subtle">📊 Demo presentation <br /> Aug 27, 2025</div>
                            <div className="action-item bg-success-subtle">📑 Send proposal <br /> After demo</div>
                        </div>

                        {/* Team Members */}
                        <div className="card p-3">
                            <h6 className="fw-bold mb-2">👥 Team Members</h6>
                            <p>🧑 John Smith <small className="text-muted">Lead Owner</small></p>
                            <p>👩 Emma Davis <small className="text-muted">Sales Manager</small></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LeadScreen;
